// The theme's sliders used to download every photo inside them as soon as a page opened:
// slides nobody had swiped to yet, and on phones even the laptop menu's photos, which phones never show.
// With this off, the browser fetches each slider photo when it comes into view, like every other photo.
if (window.FoxTheme && FoxTheme.Swiper && FoxTheme.Swiper.Swiper) {
  FoxTheme.Swiper.Swiper.extendDefaults({ preloadImages: false });
}